import { AggregatedReactionsBar } from "src/components/common/aggregated-reactions-bar/aggregated-reactions-bar";
import { IAggregatedReactionsBar } from "src/components/common/aggregated-reactions-bar/types";

export const FeedCardAggregatedReactions = ({ topNumberOfReactions, reactions }: IAggregatedReactionsBar) => {
    return <AggregatedReactionsBar topNumberOfReactions={topNumberOfReactions} reactions={reactions} />;
};
